export const en = {
  networkPage: {
    meta: { title: 'Our Network' },
    hero: {
      eyebrow: '1,400+ nonprofits',
      heading_main: 'A whole new pipeline of',
      heading_em: 'willing hands',
      lead: "Join Purposely and tap into thousands of corporate volunteers across our partner companies. Post the shifts you need, post the projects you've been putting off, and let us match the right people to the right work.",
      cta: 'Book a meeting to learn more',
    },
    stats: [
      { n: '42,000+', label: 'Corporate volunteers in the active pool' },
      { n: '180+',    label: 'Partner companies, from 50-person to Fortune 500' },
      { n: '88%',     label: 'Volunteer return rate across the network' },
      { n: '$0',      label: 'Cost for verified nonprofits — always' },
    ],
    features: {
      eyebrow: 'What You Get',
      heading_main: 'Everything you need to',
      heading_em: 'turn willing hands into impact',
      lead: "Free for verified nonprofits. We match employees to whatever work you have — from Friday meal packs to that website refresh you've put off for two years.",
      network: {
        tag: 'Tap Into the Network',
        heading_main: 'Thousands of employees,',
        heading_em: 'matched to your cause',
        body: "Employees let us know what they're looking for — by location, cause interest, and skills. You don't have to recruit, our system reaches out to you automatically.",
        bullets: [
          'Group bookings for larger teams',
          'Local match — volunteers are filtered by city',
          'Skills-based routing for pro-bono and specialist work',
        ],
      },
      projects: {
        tag: 'Big and Small Projects',
        heading_main: 'Not just the typical shift —',
        heading_em: "the projects you've kept on the back burner, too",
        body: "A meal pack on Friday is great. So is a one-off skilled team that finally rebuilds your donor database, refreshes your website, or paints the back room.",
        bullets: [
          'Recurring shifts — meal packs, reception desks, sorting drives',
          'One-off events — galas, runs, holiday drives, community days',
          'Skilled pro-bono — design, dev, finance, legal, copywriting',
          '"Backburner" projects — the things you\'ve never had hands for',
        ],
      },
      kits: {
        tag: 'Official Purposely Partner',
        heading_main: 'From KITS to CAUSE',
        heading_em: 'Hands-on and high-impact',
        body: "Kits for a Cause is one of our featured partners, bringing hands-on kit-packing experiences — hygiene kits, school kits, newcomer kits, comfort kits — matched to a charity you care about. Their wholesale buying power means every dollar goes further than if you sourced it yourself.",
        bullets: [
          'Custom designed kits determined by real-time charity needs',
          'Sourcing and logistics handled — supplies arrive on-site',
          '1–2 hour packing sessions, 20–8,000 volunteers',
          'A speaker from the charity for an interactive experience',
          'Connected to charities & nonprofits of all types across Canada and USA',
        ],
        quote: '"Working with Kits for a Cause was such an easy smooth process! They are amazingly helpful and so organized! Our kit packing event went off without a hitch."',
        quoteBy: '— Te-Anna VanDyke, Meridian Credit Union',
        metaSession: 'Session',
        metaSessionVal: '1–2h',
        metaTeam: 'Team size',
        metaTeamVal: '20–8,000',
        metaKits: 'Kits / session',
        metaKitsVal: '500–5,000',
      },
    },
    logos: {
      label: 'A few of the 1,400+ nonprofits in our network',
      items: ['Vancouver Food Bank', 'Union Gospel Mission', 'YWCA Metro', 'BGC Canada', 'Covenant House', 'Stanley Park Ecology', 'DLS Reading'],
    },
    faq: {
      eyebrow: 'Joining the network',
      heading: 'Questions, answered.',
      items: [
        {
          q: 'Is Purposely free for nonprofits?',
          a: 'Yes — fully free for verified 501(c)(3), Canadian registered charities, and equivalent international nonprofits. Corporate partners pay the platform fee.',
        },
        {
          q: 'How do you verify nonprofits?',
          a: 'We check IRS, CRA, and equivalent registries; confirm a working contact at the org; and run a brief programs review. Most applications are approved within 3–5 business days.',
        },
        {
          q: 'Do we have to take everyone who RSVPs?',
          a: 'No. You set the cap on every shift, and you can require waivers, age minimums, or training before approval. Your portal is the source of truth — Purposely just feeds qualified volunteers in.',
        },
        {
          q: 'Can we post specialist or pro-bono work?',
          a: "Absolutely — and we encourage it. Tag the skills you need (design, dev, finance, legal, copywriting, ops) and we'll route the post to volunteers whose corporate role matches.",
        },
        {
          q: 'How does Kits for a Cause work?',
          a: 'We meet with you to co-design a kit that fits your community. We source the supplies and ship them to the packing venue. Corporate teams pack the kits during a 2–4 hour event, and the kits go directly into your distribution channels afterward.',
        },
      ],
    },
    cta: {
      heading_main: "Get the help you've been",
      heading_em: 'waiting for',
      sub: 'Apply to join the network — free for verified nonprofits, and approved in under a week.',
      micro: 'No credit card. No platform fees. Ever.',
      button: 'Apply to join →',
    },
  },
}
